import { Chain, ChainID } from '@ankr.com/chains-list';

import { getAllPathsByChain } from './getAllPathsByChain';

interface GetPathsByChainIDParams {
  chainID: ChainID | undefined;
  chains: Chain[];
  allChainsPaths: string[];
}

const defaultPaths: string[] = [];

export const getPathsByChainID = ({
  allChainsPaths,
  chainID,
  chains,
}: GetPathsByChainIDParams) => {
  if (chainID) {
    const currentChain = chains.find(chain => chain.id === chainID);

    if (currentChain) {
      return getAllPathsByChain(currentChain).filter(Boolean);
    }

    if (chainID === ChainID.ALL_CHAINS) {
      return allChainsPaths;
    }
  }

  return defaultPaths;
};
